<template>
    <div class="confirmation container-fluid mx-auto d-flex-center flex-column my-4 flex-fill body-container">
        <img src="../assets/img/logo.png" class="confirmation__logo mb-4" alt="" />

        <div class="bg-white py-4--5 px-4 shadow bg-opacity-75 rounded-5 d-flex-center flex-column">
            <template v-if="notif.isValid">
                <i class="fa-solid fa-circle-check fa-6x my-2 text-success"></i>
                <h2 class="w-100 my-4">{{ t.confirmRegistrationOK }}</h2>
                <h2 class="w-100 mb-4">{{ t.confirmRegistrationOK2 }}</h2>
            </template>
            <template v-else>
                <i class="fa-solid fa-circle-xmark fa-6x my-4 text-danger"></i>
                <h2 class="w-100 my-4">{{ t.msgErreurRegistration }}</h2>
                <h2 class="w-100 mb-4">{{ t.msgErreurRegistration2 }}</h2>
            </template>
        </div>
    </div>
</template>

<script>
import { t } from "../locale/language";
import router from "../plugins/router";

export default {
    data() {
        var notif = {};
        if (localStorage.p) {
            notif = JSON.parse(localStorage.p);
            localStorage.p = null;
        }

        if (!notif) {
            router.push({ name: "home" });
            notif = {
                isValid: false,
                message: "No notification data found.",
            };
        }

        return {
            t,
            notif,
        };
    },
};
</script>
